<template>
    <div class="DesignExamplesLayout">
        <nav class="DesignExamplesLayout__sidebar">
            <router-link :to="{ name: 'examples' }" class="DesignExamplesLayout__back">
                ← Design Examples
            </router-link>
            <div v-if="isColorsSection" class="DesignExamplesLayout__navGroup">
                <router-link
                    :to="{ name: 'examples.colors' }"
                    class="DesignExamplesLayout__link"
                    active-class="DesignExamplesLayout__link--active"
                >
                    Colors
                </router-link>
            </div>
            <div v-if="isComponentsSection" class="DesignExamplesLayout__navGroup">
                <router-link
                    :to="{ name: 'examples.components.badges' }"
                    class="DesignExamplesLayout__link"
                    active-class="DesignExamplesLayout__link--active"
                >
                    Badges
                </router-link>
                <router-link
                    :to="{ name: 'examples.components.buttons' }"
                    class="DesignExamplesLayout__link"
                    active-class="DesignExamplesLayout__link--active"
                >
                    Buttons
                </router-link>
                <router-link
                    :to="{ name: 'examples.components.dropdowns' }"
                    class="DesignExamplesLayout__link"
                    active-class="DesignExamplesLayout__link--active"
                >
                    Dropdowns
                </router-link>
                <router-link
                    :to="{ name: 'examples.components.expandable' }"
                    class="DesignExamplesLayout__link"
                    active-class="DesignExamplesLayout__link--active"
                >
                    Expandable
                </router-link>
                <router-link
                    :to="{ name: 'examples.components.form' }"
                    class="DesignExamplesLayout__link"
                    active-class="DesignExamplesLayout__link--active"
                >
                    Form
                </router-link>
                <router-link
                    :to="{ name: 'examples.components.modals' }"
                    class="DesignExamplesLayout__link"
                    active-class="DesignExamplesLayout__link--active"
                >
                    Modals
                </router-link>
                <router-link
                    :to="{ name: 'examples.components.popover' }"
                    class="DesignExamplesLayout__link"
                    active-class="DesignExamplesLayout__link--active"
                >
                    Popover
                </router-link>
            </div>
        </nav>
        <main class="DesignExamplesLayout__content">
            <slot />
        </main>
    </div>
</template>

<style lang="scss" scoped>
.DesignExamplesLayout {
    display: flex;
    min-height: 100vh;
    background: var(--eidTechGray-10);

    &__sidebar {
        display: flex;
        flex-direction: column;
        width: 200px;
        min-width: 200px;
        padding: 1.5rem 1rem;
        background: #fff;
        border-right: 1px solid var(--eidTechGray-10);
        gap: 0.25rem;
    }

    &__back {
        display: block;
        margin-bottom: 1rem;
        padding: 0 0.75rem;
        font-size: 0.8125rem;
        color: var(--eidTechGray-75);
        text-decoration: none;

        &:hover {
            color: var(--eidSecureBlue);
        }
    }

    &__navGroup {
        display: flex;
        flex-direction: column;
        gap: 0.125rem;
        margin-bottom: 0.5rem;
    }

    &__groupHeading {
        margin: 0.5rem 0 0.25rem;
        padding: 0 0.75rem;
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: var(--eidTechGray-50);
    }

    &__link {
        padding: 0.5rem 0.75rem;
        border-radius: 0.375rem;
        font-size: 0.875rem;
        color: var(--eidTechGray);
        text-decoration: none;
        transition: background 0.15s;

        &:hover {
            background: var(--eidTechGray-10);
        }

        &--active {
            background: var(--eidSecureBlue-10);
            color: var(--eidSecureBlue);
            font-weight: 500;
        }
    }

    &__content {
        flex: 1;
        padding: 2rem;
        overflow: auto;
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'DesignExamplesLayout',
        computed: {
            isColorsSection(): boolean {
                return String(this.$route.name || '').startsWith('examples.colors');
            },
            isComponentsSection(): boolean {
                return String(this.$route.name || '').startsWith('examples.components');
            },
        },
    });
</script>
